export const SET_SSID = 'SET_SSID';
export const SET_LS_STORE_ID = 'SET_LS_STORE_ID';
export const SET_LADIPAGE_INFO = 'SET_LADIPAGE_INFO';
